const get = (key: string) => {
  // @ts-ignore
  return ((window._env ?? {})[key] ?? process.env[key]) || "";
};

const env = {
  provider: get("REACT_APP_ENV_PROVIDER") ?? "101D",
  api: {
    baseUrl: {
      logoutUrl: `${get("REACT_APP_TOKEN_BASE_URL")}logout?client_id=${get(
        "REACT_APP_AUTH_CODE_APPID"
      )}&logout_uri=${get("REACT_APP_ROOT_URL")}/logout`,
      tokenBaseUrl: get("REACT_APP_TOKEN_BASE_URL"),
      identityService:
        get("REACT_APP_BASE_API_URL") +
        get("REACT_APP_IDENTITY_SERVICE_BASE_URL"),
      walletService:
        get("REACT_APP_BASE_API_URL") +
        get("REACT_APP_WALLET_SERVICE_BASE_URL"),
      membershipService:
        get("REACT_APP_BASE_API_URL") +
        get("REACT_APP_MEMBERSHIP_SERVICE_BASE_URL"),
      bankService:
        get("REACT_APP_BASE_API_URL") + get("REACT_APP_BANK_SERVICE_BASE_URL"),
      dataLoaderService:
        get("REACT_APP_BASE_API_URL") +
        get("REACT_APP_DATA_LOADER_SERVICE_BASE_URL"),

      documentRepositoryService:
        get("REACT_APP_BASE_API_URL") +
        get("REACT_APP_DOCUMENT_REPOSITORY_SERVICE_BASE_URL"),
      auditService:
        get("REACT_APP_BASE_API_URL") + get("REACT_APP_AUDIT_SERVICE_BASE_URL"),
      accountService:
        get("REACT_APP_BASE_API_URL") +
        get("REACT_APP_ACCOUNT_WALLET_SERVICES_BASE_URL"),
      merchantService:
        get("REACT_APP_BASE_API_URL") +
        get("REACT_APP_MERCHANT_SERVICES_BASE_URL"),
      enterpriseService:
        get("REACT_APP_BASE_API_URL") +
        get("REACT_APP_ENTERPRISE_DATA_SERVICES_BASE_URL"),
      paymentService:
        get("REACT_APP_BASE_API_URL") +
        get("REACT_APP_PAYMENT_SERVICE_BASE_URL"),
      countryService:
        get("REACT_APP_BASE_API_URL") +
        get("REACT_APP_COUNTRY_SERVICE_BASE_URL"),
      businessActivityService:
        get("REACT_APP_BASE_API_URL") +
        get("REACT_APP_BUSINESS_ACTIVITY_BASE_URL"),
      reconciliationService:
        get("REACT_APP_BASE_API_URL") +
        get("REACT_APP_RECONCILIATION_SERVICE_BASE_URL"),
    },
    uploadFolderPath: get("REACT_APP_UPLOAD_FOLDER_PATH"),
    clientId: get("REACT_APP_CLIENT_ID"),
    clientSecret: get("REACT_APP_CLIENT_SECRET"),
    authScope: get("REACT_APP_AUTH_SCOPE"),
  },
  app: {
    appName: get("REACT_APP_NAME"),
    rootUrl: get("REACT_APP_ROOT_URL"),
    adRoles: get("REACT_APP_AD_ROLES"),
    authCodeAppId: get("REACT_APP_AUTH_CODE_APPID"),
    apiCafeUrl: get("REACT_APP_API_CAFE_URL"),
    dataSetDakkoPayslipDs: get("REACT_APP_UPLOAD_DATASET_DAKKO_PAYSLIP_DS"),
    dataSetPayrollDs: get("REACT_APP_UPLOAD_DATASET_PAYROLL_DS"),
    dataSetTpppMerchant: get("REACT_APP_UPLOAD_DATASET_TPPP_MERCHANT"),
    tpppUploadTemplateUrl: get("REACT_APP_TPPP_UPLOAD_TEMPLATE"),
    paymentWebhookEventCode: get("REACT_APP_PAYMENT_WEBHOOK_EVENT_CODE"),
    dataSetTransaction: get("REACT_APP_UPLOAD_DATASET_TRANSACTION"),
    transactionUploadTemplateUrl: get("REACT_APP_TRANSACTION_TEMPLATE"),
    userGuideUrls: {
      enterpriseBankAdmin: get(
        "REACT_APP_ENTERPRISE_BANK_ADMIN_USER_GUIDE_URL"
      ),
      enterpriseAdmin: get("REACT_APP_ENTERPRISE_ADMIN_USER_GUIDE_URL"),
      enterprisePaymentOperation: get(
        "REACT_APP_ENTERPRISE_PAYMENT_OPERATION_USER_GUIDE_URL"
      ),
      enterpriseSalesTeamMember: get(
        "REACT_APP_ENTERPRISE_SALES_TEAM_MEMBER_USER_GUIDE_URL"
      ),
      enterpriseDeveloper: get("REACT_APP_ENTERPRISE_DEVELOPER_USER_GUIDE_URL"),
    },
  },
};

export default env;
